import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangaData';

export default function CategoryOverview() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            漫画分类导览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            八大漫画分类，精准定位你的阅读喜好
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.articleCount}部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}